module.exports = __webpack_public_path__ + "static/img/dlbg.ccfaf66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dlbg.png
// module id = S+P/
// module chunks = 1